module.exports = __webpack_public_path__ + "img/symbol_7.58066df8.png";